import React, { useState } from "react";
import { Checkbox, DatePicker, Form, Select } from "antd";

const nonRevenueType = [
  {
    value: "Model",
  },
  {
    value: "Renovation",
  },
  {
    value: "Office",
  },
  {
    value: "Other",
  },
];

function NonRevenueStatus() {
  const [checked, setChecked] = useState(false);
  return (
    <>
      <Form.Item
        label="Non-Revenue Unit"
        name="nonRevenueUnit"
        valuePropName="checked"
        initialValue={false}
      >
        <Checkbox onChange={() => setChecked(!checked)}></Checkbox>
      </Form.Item>
      {checked ? (
        <>
          <Form.Item label="Non-Revenue Type" name="nonRevenueType">
            <Select options={nonRevenueType} />
          </Form.Item>
          <Form.Item name="nonRevenueStart" label="Non-Revenue Start">
            <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
          </Form.Item>
        </>
      ) : null}
    </>
  );
}

export default NonRevenueStatus;
